import { BN } from './bigNumber'
// 判断是否是一个原生的对象
export function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

export function isArray(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]'
}

// 变量转字符串
export function toString(val) {
  if (val === null || val === undefined) return ''
  if (isArray(val)) return JSON.stringify(val)
  if (isPlainObject(val) && val.toString === Object.prototype.toString) return JSON.stringify(val)
  return String(val)
}

// 由一个组件，向上找到最近的指定组件
export function findComponentUpward(context, componentName) {
  let parent = context.$parent
  let name = parent.$options.name

  while (parent && (!name || [componentName].indexOf(name) < 0)) {
    parent = parent.$parent
    if (parent) name = parent.$options.name
  }
  return parent
}

// 由一个组件，向下找到最近的指定组件
export function findComponentForward(context, componentName) {
  let target = null // 目标组件
  const name = context.$options.name
  if (name === componentName) {
    target = context
  }
  if (target) {
    return target
  } else {
    // 获取当前上下文所有子组件
    const children = context.$children
    // 编历子组件
    for (const child of children) {
      target = findComponentForward(child, componentName)
      if (target) {
        return target
      }
    }
  }
  return target
}

/**
 * @params {Number} money 金额
 * @params {Number} decimals 保留小数点后位数
 * @params {String} symbol 前置符号
 * @params {Number} precision 四舍五入精度
 */
export function formatMoney(money, precision = 2, symbol = '') {
  if (!money && money !== 0 && money !== '0') return '-'
  if (money === 0 || money === '0') return '0'
  let result
  money = BN(money).toFixed(precision)
  // 获取整数，小数部分
  const [integer, decimals = ''] = money.split('.')
  result = integer
    .replace(/\B(?=(\d{3})+\b)/g, ',')
    .replace(/^/, `${symbol}`)
  if (decimals) {
    result = result + '.' + decimals
  }

  return result
}

export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0; var v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

export function hasOwn(obj, key) {
  return Object.hasOwnProperty.call(obj, key)
}

export function proxy(target, sourceKey, key) {
  Object.defineProperty(target, key, {
    configurable: true,
    enumerable: true,
    get() {
      return target[sourceKey][key]
    },
    set(newVal) {
      target[sourceKey][key] = newVal
    }
  })
}

// 将树型列表转成List
export function treeToList(treeList, res = [], children = 'childrenList') {
  treeList.forEach(item => {
    res.push({
      ...item,
      childrenList: undefined
    })

    // 如果有children
    const childrenList = item[children]
    if (childrenList && childrenList.length) {
      treeToList(childrenList, res)
    }
  })
  return res
}

// 判断一个小数的小数位数
export function getDecimalDigits(num) {
  var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/)
  if (!match) {
    return 0
  }
  return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0))
}

